import { NbJSThemeOptions, DEFAULT_THEME as baseTheme } from '@nebular/theme';

export const BLUE_THEME = {
  name: 'blue',
  base: 'default',
  variables: {
    // Solo cambiar los colores principales
    primary: '#007bff',
    success: '#28a745',
    warning: '#ffc107',
    danger: '#dc3545',
    info: '#17a2b8',
  },
}; 